import { isPresent } from 'utils'
import Moment from 'react-moment'
import PropTypes from 'prop-types'

const Period = ({ startDate, endDate, parse }) => (
  <>
    {isPresent(startDate) ? (
      <Moment format="YYYY-MM-DD" parse={parse}>
        {startDate}
      </Moment>
    ) : (
      '시작일 미설정'
    )}
    {' ~ '}
    {isPresent(endDate) ? (
      <Moment format="YYYY-MM-DD" parse={parse}>
        {endDate}
      </Moment>
    ) : (
      '종료일 미설정'
    )}
  </>
)

Period.propTypes = {
  parse: PropTypes.string,
  endDate: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.string,
  ]),
  startDate: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.string,
  ]),
}
export default Period
